"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardInsightMenuButton = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("@gooddata/util");
var sdk_model_1 = require("@gooddata/sdk-model");
exports.DashboardInsightMenuButton = function (props) {
    var isOpen = props.isOpen, items = props.items, widget = props.widget, onClick = props.onClick;
    var onMenuButtonClick = react_1.useCallback(function () {
        onClick();
    }, [onClick]);
    if (!items.length) {
        return null;
    }
    var widgetRefAsString = sdk_model_1.objRefToString(sdk_model_1.widgetRef(widget));
    var optionsIconClasses = classnames_1.default("dash-item-action-options", "dash-item-action-widget-options", "s-dash-item-action-widget-options", "dash-item-action-widget-options-" + util_1.stringUtils.simplifyText(widgetRefAsString), "s-dash-item-action-widget-options-" + util_1.stringUtils.simplifyText(widgetRefAsString), {
        "dash-item-action-widget-options-active": isOpen,
    });
    return (react_1.default.createElement("div", { className: "dash-item-action-placeholder s-dash-item-action-placeholder", onClick: onMenuButtonClick },
        react_1.default.createElement("div", { className: optionsIconClasses })));
};
//# sourceMappingURL=DashboardInsightMenuButton.js.map